import { Box, Group, Stack, Text, UnstyledButton } from '@mantine/core';
import { useTranslation } from 'react-i18next';

import { IconFigmaArrowLeft } from '@/assets/icons';
import { useGoBack } from '@/components/common/BackButton';
import { LanguageSwitcher } from '@/components/common/LanguageSwitcher';
import { ThemeToggle } from '@/components/common/ThemeToggle';

export const AuthHeader = ({ backTo }: { backTo?: string }) => {
  const { t } = useTranslation();
  const goBack = useGoBack(backTo ?? '/login');

  return (
    <Box
      px={{ base: 20, md: 40 }}
      py={16}
      style={{
        position: 'sticky',
        top: 0,
        zIndex: 100,
        backgroundColor: 'var(--color-accent-secondary)'
      }}
    >
      <Group justify="space-between" wrap="nowrap" gap={12}>
        <Group gap={10} wrap="nowrap" style={{ minWidth: 0 }}>
          {backTo && (
            <UnstyledButton
              hiddenFrom="sm"
              onClick={goBack}
              aria-label={t('common.back')}
              style={{
                width: 24,
                height: 24,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: 'var(--color-text-on-secondary)'
              }}
            >
              <IconFigmaArrowLeft size={20} strokeWidth={1.4} />
            </UnstyledButton>
          )}
          <Stack gap={0} style={{ minWidth: 0 }}>
            <Text fw={700} size="sm" c="white" lh={1.3}>
              {t('brand.name')}
            </Text>
            <Text fz={10} c="rgba(255,255,255,0.6)" lh={1.3} truncate>
              {t('brand.tagline')}
            </Text>
          </Stack>
        </Group>

        <Group gap={12} wrap="nowrap" style={{ flexShrink: 0 }}>
          <LanguageSwitcher />
          <Box w={1} h={16} style={{ backgroundColor: '#8d9bbd', opacity: 0.4 }} />
          <ThemeToggle />
        </Group>
      </Group>
    </Box>
  );
};
